import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { ebookSettingsSharedProps } from 'utils/prop-types';
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import Icons from 'components/icons';
import clsx from 'clsx';
import useStyles from './margin-panel.styles';

const MARGIN_VALUES = Object.freeze({
  xl: 5,
  lg: 4,
  md: 3,
  sm: 1,
});

const MarginPanel = memo(({ readerRef, margin, updateOptions, commonClasses }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const changeMargin = useCallback(
    (marginSize) => () => {
      readerRef.current.applyUserSettings({ pageMargins: marginSize })
      updateOptions({ pageMargins: marginSize })
    },
    [],
  );

  return (
    <Box className={classes.marginContainer}>
      <IconButton onClick={changeMargin(MARGIN_VALUES.xl)} className={commonClasses.iconBtn} aria-label={t('reader_icon_margin_xl')} title={t('reader_icon_margin_xl')} aria-pressed={margin === MARGIN_VALUES.xl}>
        <Icons.ReaderMarginXl
          className={clsx(commonClasses.iconSm, margin === MARGIN_VALUES.xl && commonClasses.activeIcon)}
        />
      </IconButton>
      <IconButton onClick={changeMargin(MARGIN_VALUES.lg)} className={commonClasses.iconBtn} aria-label={t('reader_icon_margin_lg')} title={t('reader_icon_margin_lg')} aria-pressed={margin === MARGIN_VALUES.lg}>
        <Icons.ReaderMarginLg
          className={clsx(commonClasses.iconSm, margin === MARGIN_VALUES.lg && commonClasses.activeIcon)}
        />
      </IconButton>
      <IconButton onClick={changeMargin(MARGIN_VALUES.md)} className={commonClasses.iconBtn} aria-label={t('reader_icon_margin_md')} title={t('reader_icon_margin_md')} aria-pressed={margin === MARGIN_VALUES.md}>
        <Icons.ReaderMarginMd
          className={clsx(commonClasses.iconSm, margin === MARGIN_VALUES.md && commonClasses.activeIcon)}
        />
      </IconButton>
      <IconButton onClick={changeMargin(MARGIN_VALUES.sm)} className={commonClasses.iconBtn} aria-label={t('reader_icon_margin_sm')} title={t('reader_icon_margin_sm')} aria-pressed={margin === MARGIN_VALUES.sm}>
        <Icons.ReaderMarginSm
          className={clsx(commonClasses.iconSm, margin === MARGIN_VALUES.sm && commonClasses.activeIcon)}
        />
      </IconButton>
    </Box>
  );
});

MarginPanel.propTypes = {
  margin: PropTypes.number.isRequired,
  ...ebookSettingsSharedProps,
};

export default MarginPanel;
